import {
  ADD_TAG,
  UPDATE_TAG,
  REMOVE_TAG
} from '../actions/tags';
import _ from 'lodash';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADD_TAG:
      if (action.tag !== null && typeof action.tag === 'string') return _.uniqBy([ action.tag, ...state ], null);
    case UPDATE_TAG:
      if(state !== INITIAL_STATE) state[action.index] = action.tag;      
      return state
    case REMOVE_TAG: 
      if(state !== INITIAL_STATE) state.splice(action.index,1);
      return (state !== INITIAL_STATE) ? state : INITIAL_STATE;
    default:
      return state
  }
};


// WEBPACK FOOTER //
// ./src/reducers/tags.js